// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1myfW","info":"PatientInfo_info__q9x28"};